import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  OnDestroy,
  Renderer2
} from '@angular/core';

@Directive({
  selector: '[appFloatingPreview]'
})
export class FloatingPreviewDirective implements OnDestroy {

  @Input('appFloatingPreview') previewValue: any;
  @Input() previewLang: string;

  private container: HTMLElement;
  private textTarget: HTMLElement;
  private arrow: HTMLElement;

  constructor(private el: ElementRef, private renderer: Renderer2) {
    this.createUI();
  }

  private createUI() {
    // Main container
    this.container = this.renderer.createElement('div');
    this.renderer.appendChild(document.body, this.container);

    this.renderer.setStyle(this.container, 'position', 'absolute');
    this.renderer.setStyle(this.container, 'display', 'none');
    this.renderer.setStyle(this.container, 'z-index', '10000');
    this.renderer.setStyle(this.container, 'pointer-events', 'none');
    this.renderer.setStyle(
      this.container,
      'filter',
      'drop-shadow(0 4px 12px rgba(0,0,0,0.15))'
    );

    // Text box
    this.textTarget = this.renderer.createElement('div');
    this.renderer.appendChild(this.container, this.textTarget);

    this.renderer.setStyle(this.textTarget, 'background', '#2c3e50');
    this.renderer.setStyle(this.textTarget, 'color', '#ffffff');
    this.renderer.setStyle(this.textTarget, 'padding', '10px 16px');
    this.renderer.setStyle(this.textTarget, 'border-radius', '6px');
    this.renderer.setStyle(this.textTarget, 'font-size', '13px');
    this.renderer.setStyle(this.textTarget, 'line-height', '1.4');
    this.renderer.setStyle(this.textTarget, 'min-width', '150px');
    this.renderer.setStyle(this.textTarget, 'max-width', '480px');
    this.renderer.setStyle(this.textTarget, 'font-family', 'Segoe UI, Tahoma, sans-serif');
    this.renderer.setStyle(this.textTarget, 'white-space', 'normal');
    this.renderer.setStyle(this.textTarget, 'word-break', 'break-word');
    this.renderer.setStyle(this.textTarget, 'overflow-wrap', 'break-word');
    this.renderer.setStyle(this.textTarget, 'border', '1px solid rgba(255,255,255,0.6)');


    // Arrow
    this.arrow = this.renderer.createElement('div');
    this.renderer.appendChild(this.container, this.arrow);

    this.renderer.setStyle(this.arrow, 'width', '0');
    this.renderer.setStyle(this.arrow, 'height', '0');
    this.renderer.setStyle(this.arrow, 'margin', '0 auto');
    this.renderer.setStyle(this.arrow, 'border-left', '8px solid transparent');
    this.renderer.setStyle(this.arrow, 'border-right', '8px solid transparent');
    this.renderer.setStyle(this.arrow, 'border-top', '8px solid #2c3e50');
  }

  private getText(): string {
    if (!this.previewValue) return '';

    if (typeof this.previewValue === 'object') {
      return this.previewValue[this.previewLang] || '';
    }

    return this.previewValue;
  }

  private position() {
    const rect = this.el.nativeElement.getBoundingClientRect();

    this.renderer.setStyle(
      this.container,
      'left',
      rect.left +
        window.scrollX +
        rect.width / 2 -
        this.container.offsetWidth / 2 +
        'px'
    );

    this.renderer.setStyle(
      this.container,
      'top',
      rect.top +
        window.scrollY -
        this.container.offsetHeight -
        5 +
        'px'
    );
  }

  private show() {
    const text = this.getText();

    if (!text || !text.trim()) {
      this.hide();
      return;
    }

    this.textTarget.textContent = text;
    this.renderer.setStyle(this.container, 'display', 'block');
    this.position();
  }

  private hide() {
    this.renderer.setStyle(this.container, 'display', 'none');
  }

  // Events (Angular 7 safe)
  @HostListener('input')
  @HostListener('focus')
  @HostListener('mouseenter')
  onShow() {
    this.show();
  }

  @HostListener('blur')
  @HostListener('mouseleave')
  onHide() {
    this.hide();
  }

  ngOnDestroy() {
    if (this.container) {
      this.renderer.removeChild(document.body, this.container);
    }
  }
}
